/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { translationGet } from '../fn/translation/translation-get';
import { TranslationGet$Params } from '../fn/translation/translation-get';

@Injectable({ providedIn: 'root' })
export class TranslationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `translationGet()` */
  static readonly TranslationGetPath = '/v1/Translation/Get/{translationTypeCode}/{langCode}';

  /**
   * (AllowAnonymous) ,   Restricted to [HOSPITAL|INSURER|KIOSK_HOME].
   *
   * <br />Anonymous access
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `translationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  translationGet$Response(params: TranslationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return translationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * (AllowAnonymous) ,   Restricted to [HOSPITAL|INSURER|KIOSK_HOME].
   *
   * <br />Anonymous access
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `translationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  translationGet(params: TranslationGet$Params, context?: HttpContext): Observable<string> {
    return this.translationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
